import { useCallback } from "react";

import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { PATIENT_HEADER_QUERY } from "features/patients/use-patient.hook";
import useEmail from "hooks/use-email.hook";
import { useGetPatientQuery } from "services/patients";

type EmailMenuProps = {
  patientId?: number;
  label?: string;
  disabled?: boolean;
  expanded?: boolean;
};
export default function EmailMenu({
  patientId,
  label = "Email",
  expanded,
  disabled
}: EmailMenuProps) {
  const { handleOpen } = useEmail();

  const { data: patient } = useGetPatientQuery(
    { patientId: patientId!, query: PATIENT_HEADER_QUERY },
    {
      skip: !Boolean(patientId)
    }
  );

  const openEmailForm = useCallback(() => {
    return handleOpen({ patient });
  }, [handleOpen, patient]);

  if (!expanded) {
    return (
      <Tooltip title={label}>
        <IconButton
          onClick={openEmailForm}
          data-testid="email-mini-button"
          disabled={disabled}
        >
          <EmailIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      disabled={disabled}
      onClick={openEmailForm}
      data-testid="email-expanded-button"
      startIcon={<EmailIcon />}
    >
      {label}
    </Button>
  );
}
